export const Display = function (props) {
    let { show } = props;

    return show ? props.children : null;
};
